import React, { useCallback, useEffect, useState } from "react";
import ProcessLayout from "../Common/ProcessLayout";
import { API_URL } from "../../imports";
import axios from "axios";
import FilesToProcess from "../Common/FilesToProcess";
import Process from "../Common/Process";
import CurrentProcessLogs from "../Common/CurrentProcessLogs";
import FilewiseStatusLogs from "../Common/FilewiseStatusLogs";
import Popup from "../Common/Popup";
import { handleApiError } from "../Common/APIUtils";
import { formattedStartDateTime } from "../Common/CommonUtils";

function Refined() {
    const [startProcess, setStartProcess] = useState(false);
    const [backgroundProcess, setBackgroundProcess] = useState(false);
    const [filesData, setFilesData] = useState([]);
    const [fetchedFilesData, setFetchedFilesData] = useState([]);
    const [logsData, setLogsData] = useState([]);
    const [processedFiles, setProcessedFiles] = useState([]);
    const [unprocessedFiles, setUnProcessedFiles] = useState([]);
    const [serverStatus, setServerStatus] = useState(false);
    const [serviceUrl, setServiceUrl] = useState("");
    const [serverLoadState, setServerLoadState] = useState(true);
    const [Loader, setLoader] = useState(true);
    const [processOption, setProcessOption] = useState("normal");
    const [serverOFF, setServerOFF] = useState(false);
    const [startIndex, setStartIndex] = useState(undefined);
    const [endIndex, setEndIndex] = useState(undefined);
    const [rowSelection, setRowSelection] = useState({});
    const [fslstartIndex, setfslStartIndex] = useState(undefined);
    const [fslendIndex, setfslEndIndex] = useState(undefined);
    const [fslrowSelection, setfslRowSelection] = useState({});

    let [isOpenPopup, setIsOpenPopup] = useState(false);
    let [msg, setMsg] = useState(false);
    let [isSuccess, setIsSuccess] = useState(false);

    function closePopup() {
        setIsOpenPopup(false);
    }

    const openPopup = useCallback(() => {
        setIsOpenPopup(true);
    }, [setIsOpenPopup]);

    const handleStartProcess = async (data) => {
        if (processOption === "normal") {
            setStartProcess(true);

            const initialFiles = data.map((file) => {
                return { ...file, status: null, creation_date: "" };
            });

            setFilesData(initialFiles);
            setLogsData([]);

            const currentLogs = [];
            const updatedProcessedFiles = [];
            const updatedUnprocessedFiles = [];

            for (let i = 0; i < data.length; i++) {
                let startdt = formattedStartDateTime();
                let file = data[i];
                file.status = "Inprogress";
                file.start_date_time = startdt;
                file.creation_date = "";
                setFilesData((prevData) => {
                    const newData = [...prevData];
                    newData[i] = file;
                    return newData;
                });
                try {
                    const response = await axios.post(
                        `${API_URL}/refinedanswers/refined_process/${sessionStorage.getItem(
                            "projectCode"
                        )}`,
                        {
                            filename: file.filename,
                            response: "",
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem(
                                    "access_token"
                                )}`,
                            },
                        }
                    );

                    if (response.data.log.status_code === 0) {
                        // Update the status of the current file to "success"
                        file.status = "success";
                        file.response = response.data.log.response;
                        const date = new Date();
                        file.creation_date = date;
                        updatedProcessedFiles.push(file); // Add to processedFiles
                        currentLogs.push({
                            filename: file.filename,
                            creation_date: date,
                            api_version:
                                response.data.log.response["api_version"],
                            ...response.data.log,
                        });
                        // for (let y = 0; y < response.data.data.length; y++) {
                        //     currentLogs.push({
                        //         filename: file.filename,
                        //         creation_date: date,
                        //         ...response.data.data[y],
                        //     });
                        // }
                    } else {
                        // Update the status of the current file to "error"
                        file.status = "error";
                        file.response = null;
                        const errordate = new Date();
                        file.creation_date = errordate;
                        updatedUnprocessedFiles.push(file); // Add to unprocessedFiles
                        currentLogs.push({
                            filename: file.filename,
                            creation_date: errordate,
                            ...response.data.log,
                        });
                        // for (let y = 0; y < response.data.log.length; y++) {
                        //     currentLogs.push({
                        //         filename: file.filename,
                        //         creation_date: errordate,
                        //         ...response.data.data[y],
                        //     });
                        // }
                    }
                } catch (error) {
                    // Update the status of the current file to "error"
                    file.status = "error";
                    file.response = null;
                    const errordate = new Date();
                    file.creation_date = errordate;
                    updatedUnprocessedFiles.push(file); // Add to unprocessedFiles
                }

                setFilesData((prevData) => {
                    const newData = [...prevData];
                    newData[i] = file;
                    return newData;
                });
            }

            // Update the state with the updatedFiles array
            setLogsData(currentLogs);
            setProcessedFiles(updatedProcessedFiles); // Update processedFiles state
            setUnProcessedFiles(updatedUnprocessedFiles); // Update unprocessedFiles state
            setStartProcess(false);
        } else {
            // code for background process
            setBackgroundProcess(true);
            const fileIds = data.map((file) => file.id);
            try {
                const response = await axios.post(
                    `${API_URL}/refinedanswers/background/${sessionStorage.getItem(
                        "projectCode"
                    )}`,
                    {
                        files: fileIds,
                        serverState: serverOFF
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                "access_token"
                            )}`,
                        },
                    }
                );
                if (response) {
                    setMsg(response.data.message);
                    setServerStatus(response.data.serverStatus);
                    setIsSuccess(true);
                    openPopup();
                }
            } catch (error) {
                const errorMessage = handleApiError(error);
                setMsg(errorMessage);
                setIsSuccess(false);
                openPopup();
            }
            setBackgroundProcess(false);
            ReloadData();
        }
    };

    useEffect(() => {
        const fetchTranscribedData = async () => {
            try {
                const response = await axios.get(
                    `${API_URL}/refinedanswers/closedrawfiles/${sessionStorage.getItem(
                        "projectCode"
                    )}`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                "access_token"
                            )}`,
                        },
                    }
                );
                setFetchedFilesData(response.data.data);
            } catch (error) {
                const errorMessage = handleApiError(error);
                setMsg(errorMessage);
                setIsSuccess(false);
                openPopup();
            } finally {
                setTimeout(() => {
                    setLoader(false);
                }, 100);
            }
        };
        const fetchStatus = async () => {
            try {
                const response = await axios.get(`${API_URL}/instancemonitor`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            "access_token"
                        )}`,
                    },
                    params: {
                        server_instance: "QA/DEMO",
                    },
                });
                if (response) {
                    setServerStatus(response.data.data[0].serverStatus);
                    setServiceUrl(response.data.data[0].service_url);
                }
            } catch (error) {
                const errorMessage = handleApiError(error);
                if (errorMessage) {
                    setServerStatus(false);
                    setServiceUrl("");
                }
            } finally {
                setServerLoadState(false);
            }
        };
        fetchTranscribedData();
        fetchStatus();
    }, [setFetchedFilesData, setServerStatus, openPopup]);

    const ReloadData = useCallback(() => {
        setLoader(true);
        setRowSelection({});
        setStartIndex(undefined);
        setEndIndex(undefined);
        const reloadTranscribedData = async () => {
            try {
                const response = await axios.get(
                    `${API_URL}/refinedanswers/closedrawfiles/${sessionStorage.getItem(
                        "projectCode"
                    )}`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                "access_token"
                            )}`,
                        },
                    }
                );
                setFetchedFilesData(response.data.data);
            } catch (error) {
                const errorMessage = handleApiError(error);
                setMsg(errorMessage);
                setIsSuccess(false);
                openPopup();
            } finally {
                setTimeout(() => {
                    setLoader(false);
                }, 100);
            }
        };
        reloadTranscribedData();
    }, [setFetchedFilesData, openPopup]);

    const tabs = [
        {
            id: 1,
            title: "Raw Proceesed Files",
            content: (
                <FilesToProcess
                    serverStatus={serverStatus}
                    ReloadData={ReloadData}
                    items={fetchedFilesData}
                    startProcess={startProcess}
                    backgroundProcess={backgroundProcess}
                    setFilesData={handleStartProcess}
                    Loader={Loader}
                    setProcessOption={setProcessOption}
                    setServerOFF={setServerOFF}
                    startIndex={startIndex}
                    endIndex={endIndex}
                    setStartIndex={setStartIndex}
                    setEndIndex={setEndIndex}
                    rowSelection={rowSelection}
                    setRowSelection={setRowSelection}
                />
            ),
        },
        {
            id: 2,
            title: "Refined Process",
            content: (
                <Process
                    startProcess={startProcess}
                    selectedFilesToProcess={filesData}
                />
            ),
        },
        {
            id: 3,
            title: "Logs",
            content: (
                <CurrentProcessLogs
                    logs={logsData}
                    processedfiles={processedFiles}
                    unprocessedfiles={unprocessedFiles}
                />
            ),
        },
        {
            id: 4,
            title: "All Files Status",
            content: (
                <FilewiseStatusLogs
                    fetchFilewiseAPIURL={`refinedanswers/filewisestatusrpt/${sessionStorage.getItem(
                        "projectCode"
                    )}`}
                    fileDetailsAPIURL={`refinedanswers/fileDetailsLog/${sessionStorage.getItem(
                        "projectCode"
                    )}`}
                    CloseAPIURL={`refinedanswers/closefiles/${sessionStorage.getItem(
                        "projectCode"
                    )}`}
                    singleCSVDownloadAPI={`refinedanswers/getdownloadcsv/${sessionStorage.getItem(
                        "projectCode"
                    )}`}
                    multipleCSVDownloadAPI={`refinedanswers/downloadcsv/${sessionStorage.getItem(
                        "projectCode"
                    )}`}
                    multipleLogsDownloadAPI={`refinedanswers/downloadlogs/${sessionStorage.getItem(
                        "projectCode"
                    )}`}
                    process_code="REFINED"
                    startIndex={fslstartIndex}
                    endIndex={fslendIndex}
                    setStartIndex={setfslStartIndex}
                    setEndIndex={setfslEndIndex}
                    rowSelection={fslrowSelection}
                    setRowSelection={setfslRowSelection}
                />
            ),
        },
    ];

    return (
        <>
            <Popup
                isOpen={isOpenPopup}
                msg={msg}
                closeModal={closePopup}
                isSuccess={isSuccess}
            />
            <ProcessLayout
                startProcess={startProcess}
                tabs={tabs}
                server="VTI Service"
                serverStatus={serverStatus}
                serviceUrl={serviceUrl}
                serverLoadState={serverLoadState}
                batching={false}
            />
        </>
    );
}

export default Refined;
